function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-1060592218/c8GcCIDIrrUBENq03fkD',
      'event_callback': callback
  });
  return false;
}

const clickyLog = ( eventName ) => {
	if( typeof clicky !== 'undefined' )
	{
		let description = "- - -";
		let eventType = "click"; // [click|download|outbound|pageview]

		switch( eventName )
		{
			case "example-procedure-download":
				description = "[download] Example Procedure";
				eventType = "download";
				break;
			case "login-click":
				description = "[click] Login Button";
				break;
			case "signup-form-complete":
				description = "[click] Signup Submit Button";
				break;
		}

		clicky.log( window.location.href, description, eventType);
		// console.log( window.location.pathname );
	}
}